/**
 * Alvo D round2 (mockup 03/2a+2b) — o fio contínuo LIGADO POR PADRÃO.
 *
 * Decisão da rodada 2: quem tem a capability `person-transcript-read` abre a
 * conversa já no fio completo; «ver só esta conversa» é o opt-out, persistido
 * por operador (localStorage). Sem a cap: nada muda (o universo inteiro segue
 * gated por cap ∧ `LUME_PERSON_TRANSCRIPT_ENABLED` no servidor — regra do
 * silêncio degrada quando não aplicável).
 *
 * Helper puro (padrão inbox-defaults): o wiring é pinado por spec.
 */
export const FIO_STORAGE_KEY = 'lume:fio-completo';

export function resolveFioDefault(hasCap: boolean, stored: string | null): boolean {
  return hasCap && stored !== 'off';
}

export function readFioChoice(): string | null {
  try {
    return localStorage.getItem(FIO_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function persistFioChoice(active: boolean): void {
  try {
    localStorage.setItem(FIO_STORAGE_KEY, active ? 'on' : 'off');
  } catch {
    // storage indisponível (private mode) — a escolha só não persiste.
  }
}
